import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ReservationWidget } from '../components/ReservationWidget';
import { Modal } from './Modal';

export interface ModalReservationProps {
  exampleBg?: boolean;
  show: boolean;
  onClose: () => void;
}

export const ModalReservation: FC<ModalReservationProps> = ({ show, onClose, exampleBg }) => {
  const __ = useTranslation().t;
  const modalProps = {
    show,
    onClose,
    type: 'default',
    exampleBg,
    title: __('bookLiveClass'),
  };

  return (
    <StyledModal {...modalProps}>
      <ReservationWidget />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-width: 520px;
`;
